import React from 'react';

class Grid extends React.PureComponent {
    render() {
        const { children } = this.props;

        return <section className="grid">{children}</section>;
    }
}

export default Grid;
